import React from "react";
import Button from "../ui/Button";
import EditText from "../ui/EditText";
import { Link } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import { FiUser } from "react-icons/fi";
import { FaGoogle } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="w-auto bg-[#1c233a]  font-[Parkinsans]">
      <div className=" max-w-[1700px] mx-auto">
        <div className="relative w-auto h-auto">
          {/* Main content */}
          <div className="relative z-10 p-[20px] sm:p-[30px] xl:py-[40px]">
            <div className="ml-[0px] sm:ml-[40px] xl:ml-[54px]">
              <div className="flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-[84px]  w-auto">
                {/* Left Section - Company Info & Social */}
                <div className="flex flex-col gap-[12px] sm:gap-[18px] xl:gap-[24px] justify-start items-start w-auto lg:max-w-[330px]">
                  {/* Logo Section */}
                  <Link to="/" className="relative block">
                    <div className="flex xl:justify-start xl:items-center gap-[10px] w-full ">
                      <div className="flex justify-center items-center ">
                        <img
                          src="\assets\logoWhite.png"
                          alt="Company Logo"
                          className="hidden md:block xl:w-auto xl:h-auto"
                        />
                      </div>
                    </div>
                  </Link>
                  {/* Description */}
                  <p className="text-[16px] sm:text-[20px] xl:text-[24px]  leading-[24px] sm:leading-[30px] xl:leading-[38px] text-left text-white font-[Parkinsans] w-full text-justify">
                    A symbol of <span className="font-bold">trust</span> and{" "}
                    <span className="font-bold">sustainability</span>, committed
                    to healthier soil,{" "}
                    <span className="font-bold">empowered farmers</span>, and a
                    &nbsp;
                    <span className="font-bold">greener future</span>.
                  </p>

                  {/* Social Media Icons */}
                  <div className="flex gap-[10px] sm:gap-[15px] xl:gap-[20px] justify-start items-center w-auto">
                    <Link
                      to="https://www.facebook.com/utpannorganicfertilizer/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]   border  rounded-[50px]  flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="Facebook"
                      >
                        <img
                          src="/assets/icon/faceBook.svg"
                          alt="Facebook"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] xl:w-[24px] xl:h-[24px]"
                        />
                      </button>
                    </Link>

                    <button
                      className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]    border  rounded-[50px]  flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="LinkedIn"
                    >
                      <Link
                        to="https://www.instagram.com/utpann_organic_fertilizer/#"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/assets/icon/insta.svg"
                          alt="LinkedIn"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] xl:w-[24px] xl:h-[24px]"
                        />
                      </Link>
                    </button>

                    <button
                      className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]    border  rounded-[50px]  flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="Instagram"
                    >
                      <Link
                        to="https://x.com/utpann_in"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/assets/icon/x.svg"
                          alt="Instagram"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] xl:w-[24px] xl:h-[24px]"
                        />
                      </Link>
                    </button>

                    <button
                      className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]    border  rounded-[50px]  flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="Location"
                    >
                      <Link
                        to="https://share.google/tLMsbwYYcrdbPYdL3"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {/* <img
                          src="/assets/icon/location.svg"
                          alt="Location"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] xl:w-[24px] xl:h-[24px]"
                        /> */}
                        <FaGoogle className="text-white w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] xl:w-[24px] xl:h-[24px]" />
                      </Link>
                    </button>
                  </div>
                </div>

                {/* Right Section - Contact Details & Newsletter */}
                <div className="flex flex-wrap  justify-between lg:flex-nowrap gap-8 lg:gap-[50px] w-auto lg:w-auto">
                  {/* Contact Details */}

                  {/* Center Section - Quick Links */}
                  <div className="flex flex-col justify-start items-start w-auto lg:w-[20%]">
                    <h3 className="text-[16px] sm:text-[20px] xl:text-[24px] font-bold text-white font-[Parkinsans]">
                      Quick Links
                    </h3>
                    <Link
                      to="/about"
                      className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal text-white mt-[12px] hover:opacity-75 transition-opacity"
                    >
                      About Us
                    </Link>
                    <Link
                      to="/products"
                      className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal text-white mt-[8px] hover:opacity-75 transition-opacity"
                    >
                      Products
                    </Link>
                    <Link
                      to="/press-release-gallery"
                      className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal text-white mt-[7px] hover:opacity-75 transition-opacity"
                    >
                      Press Release
                    </Link>
                    <Link
                      to="/utpann-network"
                      className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal text-white mt-[10px] hover:opacity-75 transition-opacity"
                    >
                      Utpann Network
                    </Link>
                    <Link
                      to="https://blog.utpann.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal text-white mt-[10px] hover:opacity-75 transition-opacity"
                    >
                      Blog
                    </Link>
                    <Link
                      to="/contact-us"
                      className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal text-white mt-[10px] hover:opacity-75 transition-opacity"
                    >
                      Contact Us
                    </Link>
                  </div>
                  <div className="flex flex-col gap-[11px] sm:gap-[16px] xl:gap-[22px] justify-start items-start w-auto lg:w-[30%]">
                    <h3 className="text-[16px] sm:text-[20px] xl:text-[24px] font-bold leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Parkinsans]">
                      Contact Details
                    </h3>

                    <ul className="flex flex-col justify-start items-start w-auto space-y-4">
                      <li>
                        <a
                          href="tel:+918645888881"
                          className="flex gap-[9px] sm:gap-[14px] xl:gap-[18px] justify-start items-center w-auto hover:opacity-75 transition-opacity"
                        >
                          <img
                            src="/assets/icon/call.svg"
                            alt="Phone"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] xl:w-[30px] xl:h-[30px]"
                          />
                          <span className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Parkinsans]">
                            +91 86458 88881
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="mailto:info@utpann.in"
                          className="flex gap-[9px] sm:gap-[14px] xl:gap-[18px] justify-start items-center w-auto hover:opacity-75 transition-opacity mt-[12px] sm:mt-[18px] xl:mt-[24px]"
                        >
                          <img
                            src="/assets/icon/email.svg"
                            alt="Email"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] xl:w-[30px] xl:h-[30px] self-start"
                          />
                          <span className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Parkinsans]">
                            info@utpann.in
                          </span>
                        </a>
                      </li>
                      <li>
                        <div className="flex gap-[9px] sm:gap-[14px] xl:gap-[18px] justify-start items-start w-auto mt-[7px] sm:mt-[10px] xl:mt-[14px]">
                          <img
                            src="/assets/icon/location.svg"
                            alt="Address"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] xl:w-[30px] xl:h-[30px]"
                          />
                          <p className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[24px] sm:leading-[30px] xl:leading-[38px] text-left text-white font-[Parkinsans] self-center w-[90%]">
                            Sr. No. 2373, Sim Vistar, At&Po-Pij, Ta-Vaso,
                            <br />
                            Dist-Kheda, Gujarat INDIA 387230
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>

                  {/* WhatsApp Support Section */}
                  <div className="flex flex-col justify-start items-start max-w-[320px]">
                    {/* Card Container */}
                    <div className="bg-[#242d48] p-5 sm:p-6 rounded-2xl w-full border border-white/5 shadow-xl">
                      {/* Header with Icon */}
                      <div className="flex items-center gap-3 mb-3">
                        <div className="bg-[#25D366] p-1.5 rounded-lg shadow-lg shadow-[#25d366]/20">
                          <svg
                            viewBox="0 0 24 24"
                            className="w-6 h-6 fill-white"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.886 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                          </svg>
                        </div>
                        <h3 className="text-[18px] sm:text-[22px] font-bold text-white font-[Parkinsans]">
                          WhatsApp Support
                        </h3>
                      </div>

                      {/* Description */}
                      <p className="text-[14px] sm:text-[16px] text-white/80 font-[Parkinsans] mb-6 leading-snug">
                        Chat with our team <br /> for quick assistance.
                      </p>

                      {/* Chat Button */}
                      <div className="">
                        <a
                          href="https://wa.me/918645888881"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center justify-center w-[auto] py-3 px-6 bg-[#25D366] hover:bg-[#20ba5a] text-white font-bold rounded-full transition-all duration-300 transform hover:scale-[1.02] active:scale-95 text-[16px] sm:text-[18px]"
                        >
                          Chat Now
                        </a>
                      </div>
                      {/* Status and Time */}
                      <div className="mt-4 flex items-center gap-2">
                        <div className="flex items-center gap-1.5">
                          <span className="relative flex h-3 w-3">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
                          </span>
                          <span className="text-[12px] sm:text-[14px] text-white/70 font-medium">
                            Online
                          </span>
                        </div>
                        <span className="text-white/40 text-[12px]">•</span>
                        <span className="text-[12px] sm:text-[14px] text-white/70">
                          Mon-Sat: 9 AM-6 PM
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
